import { Chip } from 'material-ui';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';

/**
 * @type {{ pending: ConditionStyles, done: ConditionStyles }}
 */
const casesMap = {
    pending: {
        backgroundColor: '#82C3FF',
    },
    done: {
        backgroundColor: '#75C422',
    },
};

/**
 * @param {{processingCondition: ProcessingCondition}} param0 
 */
export default function LetterCondition({ processingCondition }) {
    const [current, setCurrent] = 
        useState(/**@type {ProcessingCondition & {styles?: ConditionStyles} | null} */(null));

    useEffect(() => {
        setCurrent(processingCondition);
    }, [processingCondition.status]);

    return (
        <div>{current ?
            <Chip
                labelStyle={{ lineHeight: '20px' }}
                style={{ marginLeft: '5px' }}
                backgroundColor={casesMap[current.status].backgroundColor}
            >
                { _.capitalize(current.status) }
            </Chip>
            : null}
        </div>
    );
}

/**
 * @typedef {Object} ProcessingCondition
 * @property {'pending' | 'done'} status
 * @property {Date} date
 */

/**
 * @typedef {Object} ConditionStyles
 * @property {string} backgroundColor
 */



// WEBPACK FOOTER //
// ./app/components/Letters/List/LetterCondition.jsx